/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AuthPostForgotPassword = {
  id: 'authentication.forgot-password.post',
  tag: 'Authentication',
  summary: 'Forgot password',
  description: 'Forgot users password',
  method: 'post',
  route: () => `/authentication/forgot-password`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            email: ZodTypes.TrimmedString.min(1).email(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({}).optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
